export default __webpack_public_path__ + "static/media/image-3.c396e4b3.gif";